import React, {FC} from 'react';
import DashboardWrapper from "../../Components/widgets/dashboard_wrapper";

const UserProfile:FC = () => {
    return (
        <DashboardWrapper>
            <div>
                <h5>user profile</h5>
            </div>
        </DashboardWrapper>
    )
}

export default UserProfile;